import { client } from "api";

export type GenerateReportRequest = { orderId: string; recpEmail: string; checklistIds: string[] };
export type GenerateReportResponse = { reportToken: string };

export const generateReport = (data: GenerateReportRequest) =>
  client.post<GenerateReportResponse>(`/order/report`, data).then((res) => res.data);
